'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { IconProps } from './Icon.types';

import styles from './Icon.module.scss';

export function Icon({
  style,
  className,
  icon,
  size = 'md',
  testId = 'ui-icon',
  ref,
  ...rest
}: IconProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(
        styles['icon'],
        size && styles[`icon--${size}`],
        className,
      )}
      data-testid={testId}
      {...rest}
    >
      {icon}
    </div>
  );
}
